import { InstructionNodeModel } from '../symbols';

export class GetInstructions {
  static readonly type = '[Instructions] Get tree';
}

export class CreateInstructionDirectory {
  static readonly type = '[Instructions] Create directory';
  constructor(public name: string, public parentId?: string) {}
}

export class UploadInstructionFile {
  static readonly type = '[Instructions] Upload file';
  constructor(public directoryId: string, public file: File) {}
}

export class RenameInstructionNode {
  static readonly type = '[Instructions] Rename node';
  constructor(public id: string, public name: string) {}
}

export class DeleteInstructionNode {
  static readonly type = '[Instructions] Delete node';
  constructor(public id: string) {}
}
